import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForecast = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_40335_47476)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16.0006 27.2008C17.6314 27.2008 18.9534 26.7073 18.9534 26.0987C18.9534 25.49 17.6314 24.9966 16.0006 24.9966C14.3699 24.9966 13.0479 25.49 13.0479 26.0987C13.0479 26.7073 14.3699 27.2008 16.0006 27.2008Z",
				fill: "black",
				fillOpacity: .2
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.2002 16.4924C9.2002 18.4518 9.91053 20.2325 11.0684 21.5495C11.0744 21.5618 11.0821 21.5732 11.0912 21.5831L15.1651 25.9844C15.2752 26.1038 15.4064 26.1986 15.5511 26.2632C15.6957 26.3278 15.8509 26.361 16.0077 26.3609C16.1644 26.3607 16.3195 26.3272 16.4641 26.2623C16.6086 26.1974 16.7396 26.1023 16.8495 25.9827L20.9065 21.5829C20.9137 21.5751 20.9199 21.5666 20.9251 21.5575C22.087 20.2395 22.8002 18.4558 22.8002 16.4924C22.8002 15.8624 22.7267 15.2506 22.5885 14.6665C22.5887 14.6547 22.5877 14.6428 22.5852 14.6312L22.5851 14.6311L22.5849 14.6305L22.5846 14.6286L22.5831 14.6216L22.5771 14.595C22.5692 14.5607 22.5611 14.5265 22.5528 14.4924C22.5207 14.3614 22.4867 14.2309 22.4508 14.1011C22.3573 13.7621 22.2108 13.2727 21.9978 12.6689C21.5719 11.4609 20.8802 9.7941 19.8166 7.95506C19.8016 7.92918 19.7791 7.90923 19.7526 7.89825C19.7261 7.88726 19.6969 7.88583 19.6696 7.89417C19.6422 7.90251 19.6182 7.92017 19.601 7.94447C19.5839 7.96877 19.5746 7.99839 19.5746 8.02884C19.5746 9.37214 19.2884 10.4395 18.8231 11.3705C18.1697 9.27456 16.9103 6.81574 14.4919 4.8297C14.4714 4.8129 14.4468 4.80295 14.4211 4.8011C14.3954 4.79925 14.3697 4.80558 14.3473 4.8193C14.3249 4.83302 14.3069 4.85351 14.2953 4.87821C14.2838 4.9029 14.2794 4.93069 14.2825 4.95808C14.4176 6.12568 13.8506 7.48928 13.1528 8.66542C12.4617 9.83078 11.6618 10.7801 11.366 11.1168C10.0335 12.458 9.2002 14.3703 9.2002 16.4924Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.873 6.02509C16.7729 7.87323 17.7789 10.0306 18.3096 11.8688L18.6445 13.029L19.2275 11.9724C19.5991 11.299 19.8839 10.5632 20.0479 9.7243C20.6633 10.9486 21.103 12.0423 21.4043 12.8981C21.6118 13.4876 21.7539 13.9634 21.8438 14.2897C21.8548 14.33 21.8635 14.3684 21.873 14.404L21.8721 14.405L21.9668 14.7995C22.0988 15.3459 22.1699 15.9205 22.1699 16.5134C22.1699 18.3323 21.506 19.9766 20.4355 21.1823L20.3623 21.2653L16.3887 25.5827L16.3877 25.5837C16.3346 25.6416 16.273 25.6862 16.208 25.7155C16.1432 25.7446 16.0747 25.7584 16.0068 25.7585C15.9389 25.7585 15.8706 25.7446 15.8057 25.7155C15.7406 25.6864 15.6792 25.6425 15.626 25.5847L15.625 25.5837L11.7021 21.3366L11.5645 21.1823C10.494 19.9766 9.83108 18.3322 9.83105 16.5134C9.83105 14.5571 10.5982 12.8037 11.8135 11.5798L11.8242 11.569L11.834 11.5573C12.1394 11.2092 12.9712 10.2221 13.6934 9.00262C14.2119 8.12691 14.7071 7.07371 14.873 6.02509Z",
			stroke: "#BF4BC4",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0313 21.5887C18.5371 21.0193 18.8185 20.2626 18.8169 19.4762C18.8169 17.7922 17.5557 16.4272 15.9998 16.4272C14.4439 16.4272 13.1826 17.7923 13.1826 19.4762C13.1811 20.2626 13.4625 21.0193 13.9683 21.5887H13.9654L15.4608 23.2072C15.5316 23.2841 15.616 23.3452 15.709 23.3869C15.8021 23.4285 15.9019 23.4499 16.0028 23.4498C16.1036 23.4497 16.2034 23.4281 16.2964 23.3863C16.3893 23.3444 16.4736 23.2832 16.5443 23.2061L18.033 21.5887H18.0313Z",
			fill: "#BF4BC4",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_40335_47476",
			x: 3.04785,
			y: 14.9966,
			width: 25.9053,
			height: 22.2041,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 5,
					result: "effect1_foregroundBlur_40335_47476"
				})
			]
		}) })
	]
});
export default SvgForecast;
